import React, {useState} from "react";
import {View, TouchableOpacity} from 'react-native';
import Constants from "expo-constants";
import PtText from "../core/pt-text/pt-text";
import {styleVars} from "../../app-style-vars";
import PtCallout from "../core/pt-callout/pt-callout";
import {getTranslation} from "../../helpers/getTranslation";

export default function PtUpdateChecker() {
  /** check for new code version and update process */
  /*  compare now and last update check timestamps
  /*  if interval has been exceeded, trigger XMLHTTPRequest for service-worker.js
  /*  with no caching etc..
  /*  read precacheManifestVersion from response and compare it with stored version
  /*  if new version is available, present user with message and button
  /*  which triggers window.location.reload(true) to refresh cache and stores new version data to local storage
   */

  const updateAvailableText = getTranslation('application.update.available.text') || 'App update available';
  const updateButtonLabel = getTranslation('application.update.update.button.label') || 'Update';
  const dismissButtonLabel = getTranslation('application.update.dismiss.button.label') || 'Dismiss';


  const [codeUpdateAvailable, setCodeUpdateAvailable] = useState(false);

  /** timestamp of last check for update from local storage */
  const lastCheckFromLS = global.localStorage.getItem('PT_LAST_UPDATE_CHECK');
  const lastCheckForUpdates = isNaN(parseInt(lastCheckFromLS,10)) ? 0 : parseInt(lastCheckFromLS);
  const now = new Date().getTime();
  /** check for updates interval from app.json configuration */
  const checkInterval = Constants.manifest.extra.updateCheckInterval || 86400000; // one day

  console.log('Last update check = ', lastCheckForUpdates);
  console.log('Now = ', now);
  console.log('Check Interval = ', checkInterval);
  console.log('should check = ', (now - lastCheckForUpdates > checkInterval));

  /** precache manifest version from local storage */
  const currentPrecacheManifestVersion = global.localStorage.getItem('PRECACHE_MANIFEST_VERSION');
  const [precacheManifestVersion, setPrecacheManifestVersion] = useState('unknown');

  console.log('manifest version from LS = ', currentPrecacheManifestVersion);
  console.log('manifest version in code = ', precacheManifestVersion);

  const checkPrecacheManifestVersion = () => {
    if(now - lastCheckForUpdates > checkInterval) {
      console.log('inside checking for new manifest');
      var checkReq = new XMLHttpRequest();
      checkReq.onload = () => {
        var swText = checkReq.responseText;
        var versionStart = swText.indexOf('"/precache-manifest.') + 20;
        var restOfText = swText.substring(versionStart)
        var versionEnd = restOfText.indexOf('.js');

        if (versionEnd === 32) {
          var newPrecacheManifestVersion = restOfText.substring(0, versionEnd);

          if (newPrecacheManifestVersion !== currentPrecacheManifestVersion) {
            setPrecacheManifestVersion( newPrecacheManifestVersion );
            setCodeUpdateAvailable(true);
            return newPrecacheManifestVersion;
          }
        } else {
            const checkTime = new Date().getTime().toString(10);
            global.localStorage.setItem('PT_LAST_UPDATE_CHECK', checkTime);
        }
      }

      checkReq.open('GET', '/service-worker.js?c=' + new Date().getTime());
      checkReq.setRequestHeader('Cache-Control', 'no-cache, no-store, must-revalidate');
      checkReq.send();
    }
  }

  const updateCode = () => {
    if(codeUpdateAvailable) {
      console.log('in update code')
      const checkTime = new Date().getTime().toString(10);
      global.localStorage.setItem('PT_LAST_UPDATE_CHECK', checkTime);
      global.localStorage.setItem('PRECACHE_MANIFEST_VERSION', precacheManifestVersion);
      window.location.reload(true);
    }
  }

  const dismissUpdate = () => {
    if(codeUpdateAvailable) {
      console.log('in dismiss update');
      const checkTime = new Date().getTime().toString(10);
      global.localStorage.setItem('PT_LAST_UPDATE_CHECK', checkTime);
      setCodeUpdateAvailable(false);
    }
  }

  checkPrecacheManifestVersion();

  if(codeUpdateAvailable) {
    return (
      <View style={styles.updateAvailableButtonContainer}>
        <View style={{width: '100%'}}>
          <PtCallout type={'info'} message={updateAvailableText}/>
          <TouchableOpacity onPress={() => updateCode()} style={styles.updateAvailableButton}>
            <PtText style={styles.updateAvailableText}>{updateButtonLabel}</PtText>
          </TouchableOpacity>
          <TouchableOpacity onPress={() => dismissUpdate()} style={styles.dismissUpdateButton}>
            <PtText style={styles.dismissUpdateText}>{dismissButtonLabel}</PtText>
          </TouchableOpacity>
        </View>
      </View>
    )
  } else {
    return null
  }

}

const styles = {
  updateAvailableButtonContainer: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    zIndex: 5,
    backgroundColor: 'rgba(255,255,255,.75)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  updateAvailableButton: {
    paddingHorizontal: styleVars.rem(1),
    paddingVertical: styleVars.rem(.5),
    marginVertical: styleVars.rem(1),
    marginHorizontal: styleVars.rem(.5),
    backgroundColor: styleVars.boschDarkBlue,
    justifyContent: 'center',
    alignItems: 'center',
  },
  updateAvailableText: {
    fontSize: styleVars.rem(.875),
    color: '#fff',
    textAlign: 'center',
  },
  dismissUpdateButton: {
    paddingHorizontal: styleVars.rem(1),
    paddingVertical: styleVars.rem(.5),
    marginVertical: styleVars.rem(1),
    marginHorizontal: styleVars.rem(.5),
    backgroundColor: '#fff',
    borderColor: styleVars.boschDarkBlue,
    borderWidth: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  dismissUpdateText: {
    fontSize: styleVars.rem(.875),
    color: styleVars.boschDarkBlue
  }
}